module.exports = __webpack_public_path__ + "static/media/sort-size-down.3da7aaf1.svg";